export const classes = {
  servicesList:
    'w-full min-h-0 max-h-[400px] max-w-[800px] overflow-auto py-0 pr-2',
};
